import { z } from "zod";

export const vector2dSchema = z.object({
  x: z.number(),
  y: z.number()
});

export const vector3dSchema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
  });

export const quaternionSchema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
    w: z.number(),
  });